module.exports = __webpack_public_path__ + "img/homepage.728e57c6.png";